export default "__VITE_ASSET__12b6d4fe__"